import type { JobShare } from '@/api/schema';

export const STATE_LABEL: Record<JobShare['state'], string> = {
  pending: 'Awaiting confirmation',
  sent: 'Sent',
  failed: 'Not sent',
  unknown: 'Delivery unconfirmed',
};
